import Styles from './InstructionView.module.scss';
import { AuthContext } from 'components/lib';
import { useContext } from 'react';

export function InstructionView({ data, layout = 'single' }) {
    const authContext = useContext(AuthContext);
    return (
        <div id='instr_view_parent' className={Styles.parentContainer}>
            <div className={Styles.title_container}>
                <p className={Styles.title}>
                    {data?.title}
                </p>
            </div>
            <div className={Styles.dataContainer}>
                {
                    layout === 'single' &&
                    <div className={Styles.data_single}>
                        <div className={Styles.text_container}>
                            {data?.instructions?.map((instr, index) => {
                                return (
                                    <p key={`${instr}-index${index}`}>
                                        {instr?.replace("<Company Name>", authContext?.user?.accounts[0]?.name)}
                                    </p>
                                )
                            })}
                        </div>
                        <div className={Styles.image_container} >
                            <img src={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}${data?.images}`} loading="lazy" alt='instruction icon' />
                        </div>
                    </div>
                }
                {
                    layout === 'multiple' &&
                    <div className={Styles.data_multiple}>
                        {
                            data?.instructions?.map((instr, index) => {
                                return (
                                    <div key={`${instr}-instruction${index}`} className={Styles.data_multiple_map}>
                                        {instr?.images && <img src={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}${instr?.images}`}
                                            width='5%' alt='instruction logo' />}
                                        <span>
                                            {instr?.label && <p style={{ fontSize: '0.8em', fontWeight: 600 }}>
                                                {instr?.label}:
                                            </p>}
                                            <p style={{ fontSize: '0.8em' }}>
                                                {instr?.instr?.replace("<Company Name>", authContext?.user?.accounts[0]?.name)}
                                            </p>
                                        </span>
                                    </div>
                                )
                            })
                        }
                    </div>
                }

            </div>

        </div>
    )
}
